import { default as calculationZDEcu5SkvPMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailTnfZIshO4KMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiry09DXM6eDRAMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93QqGV3GW0dGMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listLMWo0Bp0aQMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingjDpBbFHNiYMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyou3KAs1KPTbbMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellKzwBUoD9FPMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostDupr7vVONpMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thanktiNeqR4fYcMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniD2OLxtTrJeMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pagevlNTd3tHJ8Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testjMK7bDN5B5Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageBq7k1iyYOjMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleAg6vD1JFyNMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsOboUKubUr9Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tag3ickSPMGszMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorcmfrl2W5rGMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category5smbFnNPNEMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectiono15PyGxtNfMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesYB8qYjoaYeMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categorysCtCnqzDWbMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleH4yfheQKHtMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionqjwq3JwgbBMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactzyGpA42sHjMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationjX3kF8oKxxMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationHbacbMBzGoMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you1pzXytKBCFMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailMXrRW8rrccMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry5hO850gLiRMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listWpAfihd0x7Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationAnKzSlQGWVMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youG6gMiyK5IbMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiry1ZV3enQIt1Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listNe6XoS9aU3Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detail2NTVX1WchrMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offer7DleEOzfnRMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquirylLLPTr1DWeMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youDYZmN70UpCMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationcJLEAClBqrMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listEJPeyHkMNhMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youJ7LNkMVbr2Meta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineZ6Gmr864NfMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detail41H2LXMe7DMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneISVpGEU70WMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offer2gwyJiirthMeta } from "/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani-ab/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostDupr7vVONpMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thanktiNeqR4fYcMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniD2OLxtTrJeMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pagevlNTd3tHJ8Meta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testjMK7bDN5B5Meta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageBq7k1iyYOjMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleAg6vD1JFyNMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsOboUKubUr9Meta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tag3ickSPMGszMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorcmfrl2W5rGMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category5smbFnNPNEMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectiono15PyGxtNfMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesYB8qYjoaYeMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pagevlNTd3tHJ8Meta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categorysCtCnqzDWbMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleH4yfheQKHtMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionqjwq3JwgbBMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionqjwq3JwgbBMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactzyGpA42sHjMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationjX3kF8oKxxMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationHbacbMBzGoMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you1pzXytKBCFMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailMXrRW8rrccMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry5hO850gLiRMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listWpAfihd0x7Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationAnKzSlQGWVMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youG6gMiyK5IbMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiry1ZV3enQIt1Meta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listNe6XoS9aU3Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detail2NTVX1WchrMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offer7DleEOzfnRMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquirylLLPTr1DWeMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youDYZmN70UpCMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationcJLEAClBqrMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listEJPeyHkMNhMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youJ7LNkMVbr2Meta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineZ6Gmr864NfMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detail41H2LXMe7DMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneISVpGEU70WMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offer2gwyJiirthMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src2938412979/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]